import http from './HttpService'

export const addLottery = (data) => {
  const formData = new FormData()

  for (let key of Object.keys(data)) formData.append(key, data[key])

  return http.post('/store/lottery/', formData)
}
